<template>
  <div>
    <div align="left">
      <h5 class="h5 mb-3 text-primary font-weight-bold">Article</h5>
    </div>
    <br />
    <b-card class="text-left">
      <h5 class="font-weight-bold text-primary">Edit Article</h5>
      <br />
      <br />
      <b-row>
        <b-col>
          <div>
            <app-article v-if="item.category !== ''" :item="item"></app-article>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
const ArticleEdit = () => import("../component/articleEdit");

export default {
  components: {
    appArticle: ArticleEdit,
  },
  data() {
    return {
      item: {
        category: "",
        content: {
          en: "",
          id: ""
        },
        cta_button: {
          text: {
            en: "",
            id: ""
          },
          url: ""
        },
        has_shipping_rates: false,
        image: "",
        image_alt: "",
        image_webp: "",
        is_with_cta_button: false,
        is_with_quick_cta_button: false,
        meta_description: {
          en: "",
          id: ""
        },
        periode: {
          end_date: "",
          start_date: ""
        },
        quick_cta_button: {
          text: {
            en: "",
            id: ""
          },
          url: ""
        },
        shipping_rates: [],
        tags: [],
        title: {
          en: "",
          id: ""
        },
      },
    };
  },
  beforeCreate() {
    // this.$store.dispatch("getDonatur");
    this.$store
      .dispatch('ArticleModule/getArticle', this.$route.params.id)
      .then((response) => {
        this.item = response.data.data;
        if (
          response.data.data.category == 'promo'
          && response.data.data.promo_product_roles.product_master.id != ''
        ) {
          this.$store.dispatch(
            'PaxelMarketModule/getProductMasterId',
            response.data.data.promo_product_roles.product_master.id,
          );
        }
      })
      .catch((error) => {
        this.$swal({
          type: 'error',
          title: 'Oops...',
          text: error,
          showConfirmButton: false,
          timer: 1500,
        });
      });
  },
  methods: {},
};
</script>

<style scoped>
</style>
